export default "__VITE_ASSET__DP_WjsKY__"